/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Map_LoadingInputs */

const en_ticket_map_loading = /** @type {(inputs: Ticket_Map_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquiring location...`)
};

const ja_ticket_map_loading = /** @type {(inputs: Ticket_Map_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置情報を取得中...`)
};

const fr_ticket_map_loading = /** @type {(inputs: Ticket_Map_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquisition de la position...`)
};

const de_ticket_map_loading = /** @type {(inputs: Ticket_Map_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort wird ermittelt...`)
};

/**
* | output |
* | --- |
* | "Acquiring location..." |
*
* @param {Ticket_Map_LoadingInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_map_loading = /** @type {((inputs?: Ticket_Map_LoadingInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Map_LoadingInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_map_loading(inputs)
	if (locale === "ja") return ja_ticket_map_loading(inputs)
	if (locale === "fr") return fr_ticket_map_loading(inputs)
	return de_ticket_map_loading(inputs)
});